/**
 * @description interpolateContent
 * - function to parse a string and replaces specified keys with associated values.
 * - function also allows the client to specify formatting of replaced values.
 * - for examples, pls look at ../__tests__/interpolateContent.test.ts
 * @param { string } content
 * @param { InterpolationInfos } interpolationInfos
 * @return { string }
 */
export var interpolateContent = function interpolateContent(content, interpolationInfos) {
  if (!content) return '';
  var interpolatedStr = content;
  interpolationInfos.forEach(function (interpolationInfo) {
    interpolatedStr = interpolatedStr.split(interpolationInfo.key).join(interpolationInfo.formatPrefix + interpolationInfo.value + interpolationInfo.formatSuffix);
  });
  return interpolatedStr;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/interpolateContent.js
// module id = 842
// module chunks = 11